require ('../../version');

angular
    .module('app.core', [
            'js-data',
            'ui.router',
            'ui.select',
            'ngCookies',
            'pascalprecht.translate',
            //'templates-app',
            'ui.bootstrap',
            'resources',
            'services',
            'app.version',
            'decorators.bootstrapModal',
            'wj',
            'gridster',
            'googlechart',
            'directives',
            'filters',
            'constant',
            'core.init',
            'core.config',
            'core.values',
            'toastr',
            'components',
            'chart.js'
        ]);
